// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as RegionPickerDialog$PrezzeeRibbon from "../RegionPicker/RegionPickerDialog.bs.js";

function RegionIndicator(props) {
  var onChange = props.onChange;
  var selected = props.selected;
  var regions = props.regions;
  var onChange$1 = onChange !== undefined ? onChange : (function (param) {
        
      });
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  var onClose = function (param) {
    Curry._1(setIsOpen, (function (param) {
            return false;
          }));
  };
  var openModal = function (param) {
    Curry._1(setIsOpen, (function (param) {
            return true;
          }));
  };
  var onSave = function (selected) {
    Curry._1(onChange$1, selected);
    Curry._1(setIsOpen, (function (param) {
            return false;
          }));
  };
  var r = Belt_Array.get(regions, selected);
  if (r !== undefined) {
    return JsxRuntime.jsxs(React.Fragment, {
                children: [
                  props.children,
                  JsxRuntime.jsx("div", {
                        children: Curry._1(props.clickableElem, r),
                        className: BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))]),
                        onClick: openModal
                      }),
                  JsxRuntime.jsx(RegionPickerDialog$PrezzeeRibbon.make, {
                        regions: regions,
                        strings: props.strings,
                        selected: selected,
                        isOpen: match[0],
                        onSave: onSave,
                        onClose: onClose
                      })
                ]
              });
  } else {
    return null;
  }
}

var make = RegionIndicator;

export {
  make ,
}
/* react Not a pure module */
